import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { catchError, EMPTY, filter, take } from 'rxjs';
import { SnackbarService } from '../../services/snackbar.service';
import { AdminPermission } from '@mol-limo-reg/admin-api';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-admintool-layout',
  templateUrl: './admintool-layout.component.html',
  styleUrls: ['./admintool-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdmintoolLayoutComponent implements OnInit {
  public currentPermissions: AdminPermission[] = [];
  public AdminPermission = AdminPermission;
  public isMobileMenuOpen = false;
  public isRacSubMenuExpanded = false;

  constructor(
    public authService: AuthService,
    private snackbarService: SnackbarService,
    public router: Router
  ) {}

  public ngOnInit(): void {
    this.authService.profile$
      .pipe(
        filter((profile) => !!profile),
        take(1),
        untilDestroyed(this)
      )
      .subscribe((profile) => {
        this.currentPermissions = profile!.permissions;
      });
  }

  public onLogout() {
    this.authService
      .logOut$()
      .pipe(
        catchError(() => {
          this.snackbarService.error('A kijelentkezés során hiba lépett fel!');
          return EMPTY;
        })
      )
      .subscribe();
  }

  public isRacMenuActive(): boolean {
    const racRoutes = ['/copy-management', '/station-configurator', '/manage-cars', '/booking-management'];
    return racRoutes.some(route => this.router.url.startsWith(route));
  }

  public toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  public closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    this.isRacSubMenuExpanded = false;
  }

  public toggleRacSubMenu(): void {
    this.isRacSubMenuExpanded = !this.isRacSubMenuExpanded;
  }

  public navigateAndClose(route: string[]): void {
    this.router.navigate(route);
    this.closeMobileMenu();
  }
}
